/**
 * Contains the localized messages for the locale ar.
 * @type {Locale}
 */
export const ar = {
  accept: 'موافق',
  addRule: 'إضافة قاعدة',
  am: 'صباحًا',
  apply: 'تطبيق',
  cancel: 'إلغاء',
  choose: 'اختر',
  chooseDate: 'اختر اليوم',
  chooseMonth: 'اختر الشهر',
  chooseYear: 'اختر السنة',
  clear: 'إزالة',
  completed: 'مكتمل',
  contains: 'يحتوي على',
  custom: 'مخصص',
  dateAfter: 'التاريخ بعد',
  dateBefore: 'التاريخ قبل',
  dateFormat: 'yy/mm/dd',
  dateIs: 'التاريخ هو',
  dateIsNot: 'التاريخ ليس',
  dayNames: [
    'الأحد',
    'الإثنين',
    'الثلاثاء',
    'الأربعاء',
    'الخميس',
    'الجمعة',
    'السبت',
  ],
  dayNamesMin: [
    'الأحد',
    'الإثنين',
    'الثلاثاء',
    'الأربعاء',
    'الخميس',
    'الجمعة',
    'السبت',
  ],
  dayNamesShort: ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  emptyFilterMessage: 'لا توجد اختيارات',
  emptyMessage: 'لا توجد نتيجة',
  emptySearchMessage: 'لا تتوفر بيانات',
  emptySelectionMessage: 'لم يتم اختيار أي عنصر',
  endsWith: 'ينتهي بـ',
  equals: 'يساوي',
  fileChosenMessage: '{0} ملفات',
  fileSizeTypes: [
    'بايت',
    'كيلو بايت',
    'ميغابايت',
    'غيغابايت',
    'تيرابايت',
    'بيتابايت',
    'إكسابايت',
    'زيتابايت',
    'يوتابايت',
  ],
  filter: 'تصفية',
  firstDayOfWeek: 0,
  gt: 'أكبر من',
  gte: 'أكبر من أو يساوي',
  lt: 'أقل من',
  lte: 'أقل من أو يساوي',
  matchAll: 'يطابق الكل',
  matchAny: 'يطابق أي',
  medium: 'متوسط',
  monthNames: [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ],
  monthNamesShort: [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ],
  nextDecade: 'العقد القادم',
  nextHour: 'الساعة التالية',
  nextMinute: 'الدقيقة التالية',
  nextMonth: 'الشهر التالي',
  nextSecond: 'الثانية التالية',
  nextYear: 'السنة التالية',
  noFileChosenMessage: 'لم يتم اختيار أي ملف',
  noFilter: 'بدون تصفية',
  notContains: 'لا يحتوي على',
  notEquals: 'لا يساوي',
  now: 'الآن',
  passwordPrompt: 'أدخل كلمة المرور',
  pending: 'قيد الانتظار',
  pm: 'مساءً',
  prevDecade: 'العقد السابق',
  prevHour: 'الساعة السابقة',
  prevMinute: 'الدقيقة السابقة',
  prevMonth: 'الشهر السابق',
  prevSecond: 'الثانية السابقة',
  prevYear: 'السنة السابقة',
  reject: 'لا',
  removeRule: 'حذف قاعدة',
  searchMessage: '{0} النتائج المتاحة',
  selectionMessage: '{0} عناصر تم اختيارها',
  showMonthAfterYear: false,
  startsWith: 'يبدأ بـ',
  strong: 'قوي',
  today: 'اليوم',
  upload: 'تحميل',
  weak: 'ضعيف',
  weekHeader: 'الأسبوع',
  aria: {
    cancelEdit: 'إلغاء التعديل',
    close: 'إغلاق',
    collapseLabel: 'طوي',
    collapseRow: 'إخفاء الصف',
    editRow: 'تعديل الصف',
    expandLabel: 'توسيع',
    expandRow: 'إظهار الصف',
    falseLabel: 'خطأ',
    filterConstraint: 'تصفية القيود',
    filterOperator: 'تصفية المشغلات',
    firstPageLabel: 'الصفحة الأولى',
    gridView: 'واجهة جدول',
    hideFilterMenu: 'إخفاء تصفية القائمة',
    jumpToPageDropdownLabel: 'الذهاب إلى عنوان القائمة المنسدلة للصفحة',
    jumpToPageInputLabel: 'الذهاب إلى عنوان حقل الإدخال للصفحة',
    lastPageLabel: 'الصفحة الأخيرة',
    listLabel: 'قائمة الخيارات',
    listView: 'واجهة قائمة',
    maximizeLabel: 'تعظيم',
    minimizeLabel: 'تصغير',
    moveAllToSource: 'نقل الجميع إلى المصدر',
    moveAllToTarget: 'نقل الجميع إلى الهدف',
    moveBottom: 'الانتقال للأخير',
    moveDown: 'الانتقال للأسفل',
    moveTop: 'الانتقال للأول',
    moveToSource: 'نقل إلى المصدر',
    moveToTarget: 'نقل إلى الهدف',
    moveUp: 'الانتقال للأعلى',
    navigation: 'التنقل بين الصفحات',
    next: 'التالي',
    nextPageLabel: 'الصفحة التالية',
    nullLabel: 'لا يوجد اختيار',
    otpLabel: 'الرجاء إدخال حرف كلمة المرور لمرة واحدة {0}',
    pageLabel: 'صفحة {page}',
    passwordHide: 'إخفاء كلمة المرور',
    passwordShow: 'عرض كلمة المرور',
    previous: 'السابق',
    prevPageLabel: 'الصفحة السابقة',
    removeLabel: 'إزالة',
    rotateLeft: 'تدوير باتجاه اليسار',
    rotateRight: 'تدوير باتجاه اليمين',
    rowsPerPageLabel: 'عدد الصفوف في الصفحة الواحدة',
    saveEdit: 'حفظ التعديلات',
    scrollTop: 'انتقل إلى الأعلى',
    selectAll: 'تحديد جميع العناصر',
    selectColor: 'اختر اللون',
    selectLabel: 'اختيار',
    selectRow: 'اختيار الصف',
    showFilterMenu: 'إظهار تصفية القائمة',
    slide: 'شريحة',
    slideNumber: 'الشريحة رقم {slideNumber}',
    star: 'نجمة واحدة',
    stars: '{star} نجوم',
    trueLabel: 'صحيح',
    unselectAll: 'إلغاء تحديد جميع العناصر',
    unselectLabel: 'إلغاء التحديد',
    unselectRow: 'عدم اختيار الصف',
    zoomImage: 'تكبير الصورة',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
  },
};
